import client from '@/http'

const save = (context, params) => {
  client.post(
    `/dossiers`,
    params
  ).then(
    () => {}
  ).catch(
    e => console.error(e)
  )
}

const load = (context, params) => {
  client.get(
    `/dossiers/load/${params.nr}`
  ).then(
    (res) => {
      context.commit('SET_DOSSIER', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const find = (context, params) => {
  client.get(
    `dossiers/find/${params.nr}`
  ).then(
    (res) => {
      context.commit('SET_SOURCE', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const loadDiff = (context, params) => {
  client.get(
    `dossiers/diff/${params.from}/${params.to}`
  ).then(
    (res) => {
      context.commit('SET_DOSSIERS', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const loadAll = (context) => {
  context.commit('RESET')

  client.get(
    '/dossiers'
  ).then(
    (res) => {
      context.commit('SET_DOSSIERS', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const loadProfiles = (context, params) => {
  client.get(
    `dossiers/profiles/${params.nr}`
  ).then(
    (res) => {
      context.commit('SET_PROFILES', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

export default {
  save,
  find,
  load,
  loadAll,
  loadDiff,
  loadProfiles
}
